/* Shipping & Returns page (sections/ac-sh-page.liquid).

   One optional behaviour: when the URL hash names an accordion row —
   /pages/shipping-returns#warranty — open that row so the reader lands on
   the content, not a closed summary. Runs on load and on hashchange.
   Without JavaScript the browser still scrolls to the closed row. */
(function () {
  'use strict';
  function openFromHash() {
    var id = (location.hash || '').slice(1);
    if (!id) return;
    var el;
    try { el = document.getElementById(id); } catch (e) { return; }
    if (!el || el.tagName !== 'DETAILS' || !el.classList.contains('ac-sh-item')) return;
    el.open = true;
    el.scrollIntoView({ block: 'start' });
    var s = el.querySelector('summary');
    if (s) s.focus({ preventScroll: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openFromHash); else openFromHash();
  window.addEventListener('hashchange', openFromHash);
})();
